import { usePricingModulesState } from '../../../../context/contexts/PricingModuleContext';

export const useIsCloudOnly = () => {
    const { isCloudOnly } = usePricingModulesState();

    return isCloudOnly;
};
